import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { confirmSepaBatch, getSepaBatches, getSepaBatchPreviewOrders } from 'src/api/sepa-batch';
import {
    CONFIRM_SEPA_BATCH,
    fetchSepaBatches,
    FETCH_SEPA_BATCHES,
    FETCH_SEPA_BATCH_PREVIEW,
    requestConfirmSepaBatch,
    requestConfirmSepaBatchFailure,
    requestConfirmSepaBatchSuccess,
    requestSepaBatches,
    requestSepaBatchesFailure,
    requestSepaBatchesSuccess,
    requestSepaBatchPreview,
    requestSepaBatchPreviewFailure,
    requestSepaBatchPreviewSuccess,
} from './actions';

function* fetchSepaBatchesSaga(action: AnyAction): SagaIterator {
    yield put(requestSepaBatches());

    const { error, response } = yield call(getSepaBatches, action.pageable, action.batchNumber, action.confirmedState);

    if (error) {
        yield put(requestSepaBatchesFailure(error));
    } else {
        yield put(requestSepaBatchesSuccess(response));
    }
}

export function* generateFetchSepaBatchesWatcher() {
    yield takeLatest(FETCH_SEPA_BATCHES, fetchSepaBatchesSaga);
}

function* fetchSepaBatchPreviewSaga(action: AnyAction): SagaIterator {
    yield put(requestSepaBatchPreview());

    const { error, response } = yield call(getSepaBatchPreviewOrders, action.id);

    if (error) {
        yield put(requestSepaBatchPreviewFailure(error));
    } else {
        yield put(requestSepaBatchPreviewSuccess(response));
    }
}

export function* generateFetchSepaBatchPreviewWatcher() {
    yield takeLatest(FETCH_SEPA_BATCH_PREVIEW, fetchSepaBatchPreviewSaga);
}

function* confirmSepaBatchSaga(action: AnyAction): SagaIterator {
    yield put(requestConfirmSepaBatch());

    const { error, response } = yield call(confirmSepaBatch, action.id, action.sepaBatchConfirmationRequest);

    if (error) {
        yield put(requestConfirmSepaBatchFailure(error));
    } else {
        yield put(requestConfirmSepaBatchSuccess(response));
        const lastFilter = yield select((state: any) => state.offsettingSepaBatch.lastFilter);
        yield put(fetchSepaBatches(lastFilter?.pageable, lastFilter?.batchNumber, lastFilter?.confirmedState));
    }
}

export function* generateConfirmSepaBatchWatcher() {
    yield takeLatest(CONFIRM_SEPA_BATCH, confirmSepaBatchSaga);
}
